<template>
  <div class="animated fadeIn">
    <b-form @submit="generateAttendance" class="mb-2">
      <b-form-group
              label="Project:"
              description="This field is required"
      >
        <select class="form-control" v-model="form.project_id" required >
          <option value="">Please Select</option>
          <option v-for="project in projects" :value="project.id">
            {{project.title}}
          </option>
        </select>
      </b-form-group>
      <b-form-group
              label="From Date:"
              description="This field is required"
      >
        <b-form-input
                v-model="form.date_from"
                type="date"
                required
        ></b-form-input>
      </b-form-group>
      <b-form-group
              label="To Date:"
              description="This field is required"
      >
        <b-form-input
                v-model="form.date_to"
                type="date"
                required
        ></b-form-input>
      </b-form-group>

      <div class="text-right">
        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Generate Site TimeLogs</b-button>
      </div>
    </b-form>
    <b-row align-v="center" class="loader" v-if="is_loading">
      <b-col>
        <b-spinner></b-spinner>
        <br><br>
        <strong>Loading</strong>
      </b-col>
    </b-row>

    <b-row class="m-0 mb-3">
      <b-col cols="6" class="p-0">
        <b-row class="m-0">
          <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
            <font-awesome-icon icon="road" class="h2 mb-0" />
          </b-col>
          <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
            <div>
              <h4 class="mb-0"><strong>{{json_file.project.title}}</strong></h4>
              <small class="text-muted text-uppercase font-weight-bold">PROJECT TITLE</small>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="p-0 pl-3">
        <b-row class="m-0 h-100">
          <b-col cols="2" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
            <font-awesome-icon icon="calendar" class="h2 mb-0" />
          </b-col>
          <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
            <div>
              <h4 class="mb-0"><strong>{{json_file.formatted_from_date}}</strong></h4>
              <small class="text-muted text-uppercase font-weight-bold">FROM</small>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="p-0 pl-3">
        <b-row class="m-0 h-100">
          <b-col cols="2" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
            <font-awesome-icon icon="calendar" class="h2 mb-0" />
          </b-col>
          <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
            <div>
              <h4 class="mb-0"><strong>{{json_file.formatted_to_date}}</strong></h4>
              <small class="text-muted text-uppercase font-weight-bold">TO</small>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-tabs content-class="mt-3">
      <b-tab title="Included" active>
        <template v-for="(result, result_index) in json_file.result">
          <table class="table table-bordered">
            <thead>
            <tr class="bg-dark">
              <th colspan="13"><h5>{{result.date.other_formats.format_1}}</h5></th>
            </tr>
            <tr>
              <th>ID Number</th>
              <th>AM IN</th>
              <th>AM OUT</th>
              <th>PM IN</th>
              <th>PM OUT</th>
              <th>OT IN</th>
              <th>OT OUT</th>
              <th>REG</th>
              <th>OT</th>
              <th>ND</th>
              <th>AMOUNT</th>
              <th>Modify</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(log, log_index) in result.logs" v-if="!log.is_deleted">
              <td>
                <div class="text-left">
                  <span class="d-block bg-dark text-white p-1" style="min-width: 300px">ID Number : <strong>{{log.other_details.manpower_details.id_number}}</strong></span>
                  <span class="d-block p-1">Name : <strong>{{log.other_details.manpower_details.full_name}}</strong></span>
                  <span class="d-block p-1">Location : <strong>{{log.other_details.server_project_location_structure_item.project_location_structure.project_location.description}}</strong></span>
                  <span class="d-block bg-dark text-white p-1">Structure : <strong>{{log.other_details.server_project_location_structure_item.project_location_structure.description}}</strong></span>
                  <span class="d-block p-1">Item : <strong>{{log.other_details.server_project_location_structure_item.description}}</strong></span>

                  <select class="form-control mb-2" v-model="log.job_description_id" required  :disabled="(!log.is_modified)" @change="updateRate(result_index,log_index)">
                    <option value="">Please Select</option>
                    <option v-for="job_description in job_descriptions" :value="job_description.id">
                      {{job_description.description}}
                    </option>
                  </select>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Daily Rate</div>
                    </div>
                    <input type="number" class="form-control" id="inlineFormInputGroup" placeholder="Daily Rate" :readonly="(!log.is_modified)" step="any" v-model="log.daily_rate">
                  </div>
                </div>
              </td>
              <td>
                <template v-if="log.am_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.am_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_am_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.am_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.am_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_am_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.pm_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.pm_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_pm_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.pm_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.pm_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_pm_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.ot_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.ot_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_ot_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.ot_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.ot_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_ot_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.regular_hours)" :currency="false"/> hour/s-->
                <b-form-input
                        v-model="log.regular_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                <b-form-input
                        v-model="log.ot_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <b-form-input
                        v-model="log.nd_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.total)"/>-->
                <b-form-input
                        v-model="log.total"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td>
                <label class="c-switch c-switch-pill c-switch-success">
                  <input type="checkbox" class="c-switch-input" v-model="log.is_modified">
                  <span class="c-switch-slider"></span>
                </label>
              </td>
              <td>
                <b-button variant="danger" @click="log.is_deleted = !log.is_deleted">Exclude</b-button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </b-tab>
      <b-tab title="Excluded">
        <template v-for="(result, result_index) in json_file.result">
          <table class="table table-bordered">
            <thead>
            <tr class="bg-dark">
              <th colspan="13"><h5>{{result.date.other_formats.format_1}}</h5></th>
            </tr>
            <tr>
              <th>ID Number</th>
              <th>AM IN</th>
              <th>AM OUT</th>
              <th>PM IN</th>
              <th>PM OUT</th>
              <th>OT IN</th>
              <th>OT OUT</th>
              <th>REG</th>
              <th>OT</th>
              <th>ND</th>
              <th>AMOUNT</th>
              <th>Modify</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(log, log_index) in result.logs" v-if="log.is_deleted">
              <td>
                <div class="text-left">
                  <span class="d-block bg-dark text-white p-1" style="min-width: 300px">ID Number : <strong>{{log.other_details.manpower_details.id_number}}</strong></span>
                  <span class="d-block p-1">Name : <strong>{{log.other_details.manpower_details.full_name}}</strong></span>
                  <span class="d-block p-1">Location : <strong>{{log.other_details.server_project_location_structure_item.project_location_structure.project_location.description}}</strong></span>
                  <span class="d-block bg-dark text-white p-1">Structure : <strong>{{log.other_details.server_project_location_structure_item.project_location_structure.description}}</strong></span>
                  <span class="d-block p-1">Item : <strong>{{log.other_details.server_project_location_structure_item.description}}</strong></span>

                  <select class="form-control mb-2" v-model="log.job_description_id" required  :disabled="(!log.is_modified)" @change="updateRate(result_index,log_index)">
                    <option value="">Please Select</option>
                    <option v-for="job_description in job_descriptions" :value="job_description.id">
                      {{job_description.description}}
                    </option>
                  </select>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Daily Rate</div>
                    </div>
                    <input type="number" class="form-control" id="inlineFormInputGroup" placeholder="Daily Rate" :readonly="(!log.is_modified)" step="any" v-model="log.daily_rate">
                  </div>
                </div>
              </td>
              <td>
                <template v-if="log.am_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.am_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_am_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.am_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.am_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_am_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.pm_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.pm_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_pm_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.pm_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.pm_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_pm_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.ot_in!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.ot_in_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_ot_in.other_formats.format_1}}</span>
                </template>
              </td>
              <td>
                <template v-if="log.ot_out!=null">
                  <img
                          class="cursor-pointer"
                          :src="assets_path.EMPLOYEE_LOGS_URL + log.ot_out_image"
                          width="100px"
                  />
                  <span class="d-block">{{log.other_details.formatted_ot_out.other_formats.format_1}}</span>
                </template>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.regular_hours)" :currency="false"/> hour/s-->
                <b-form-input
                        v-model="log.regular_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                <b-form-input
                        v-model="log.ot_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                <b-form-input
                        v-model="log.nd_hours"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td class="text-right">
                <!--<number-format-component :input_value="Number(log.total)"/>-->
                <b-form-input
                        v-model="log.total"
                        type="number"
                        step="any"
                        :readonly="(!log.is_modified)"
                        style="width: 100px;"
                ></b-form-input>
              </td>
              <td>
                <label class="c-switch c-switch-pill c-switch-success">
                  <input type="checkbox" class="c-switch-input" v-model="log.is_modified">
                  <span class="c-switch-slider"></span>
                </label>
              </td>
              <td>
                <b-button variant="success" @click="log.is_deleted = !log.is_deleted">Include</b-button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </b-tab>
    </b-tabs>

    <b-button type="submit" variant="success" block size="sm" @click="processImport()"><font-awesome-icon icon="save" /> Process TimeLog</b-button>
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import { server_details,assets_path } from "@/config";
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
      mixins:[SwalMixin],
      components: {NumberFormatComponent},
      data: () => {
          return {
            json_file:{
              project:{
                title:''
              },
              result:[]
            },
            is_loading:false,
            file:{},
            job_descriptions:[],
            form:{
              project_id:"",
              date_from:'',
              date_to:''
            },
            projects:[],
            assets_path: {},
          }
      },
      watch: {
        json_file:{
          immediate: true,
          deep:true,
          handler(){
            if(this.json_file.result.length>0)
            {
              this.json_file.result.forEach( result => {
                const entries = Object.entries(result.logs);
                entries.forEach( log => {
                  let total_hours = Number(log.regular_hours) + Number(log.ot_hours);
                  let total = total_hours * (Number(log.daily_rate)/8);
                  log.total = total.toFixed(2);
                });
              });
            }

          }
        },
      },
      mounted() {
        this.assets_path = assets_path;
      },
      created(){
        this.getProjects();
        this.getJobDescriptions();
      },
      methods: {
        generateAttendance(){
          event.preventDefault();
          this.axios.post('site-timelog-logs/generate',this.form).then(response => {
            this.swalTransactionCompleted();
            this.json_file=response.data;
          }).catch(error => {
            console.log(error)
            this.swal_transaction_error_data.text = error.response.data;
            this.swalRequestError();
          });
        },
        getProjects(){
          this.axios.get('projects/all').then(response => {
            this.projects = JSON.parse(JSON.stringify(response.data));
          }).catch(error => console.log(error));
        },
        readJsonFile(e) {
          this.is_loading=true;
          let files = e.target.files || e.dataTransfer.files;
          if (!files.length){
            this.swal_transaction_error_data.text = 'Invalid File';
            this.swalRequestError();
          }
          if(files[0].type!='application/json'){
            this.swal_transaction_error_data.text = 'Invalid File';
            this.swalRequestError();
          }

          this.file = files[0];
          this.readFile(files[0]);
          setTimeout(() => {  this.is_loading=false; }, 10000);

        },
        readFile(file) {
          let reader = new FileReader();
          reader.onload = e => {
            let json = JSON.parse(e.target.result);
            this.json_file =json;
          };
          reader.readAsText(file);

        },
        getJobDescriptions(){
          this.axios.get('maintenance/job_descriptions/all').then(response => {
            this.job_descriptions=response.data
          }).catch(error => console.log(error));
        },
        updateRate(result_index,log_index){
          let job_description = this.job_descriptions.find(result => result.id === this.json_file.result[result_index].logs[log_index].job_description_id);
          this.json_file.result[result_index].logs[log_index].daily_rate = job_description.daily_rate.default;
        },

        processImport(){
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_loading=true;
              this.axios.post('site-timelog-logs/process',this.json_file).then(response => {
                this.swalTransactionCompleted();
              }).catch(error => {
                console.log(error)
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
              });
              this.is_loading=false;

            }
          });
        },
      }
    }
</script>
